import React from "react";
import { observer } from "mobx-react";
import {
    ShoppingCartOutlined,
    ClockCircleOutlined,
    CheckCircleOutlined,
    ExclamationCircleOutlined,
} from "@ant-design/icons";

const ArticleGalaxyMenuItem = observer(({ article }) => {
    const status = article.fullTextOrder?.status || "unknown";

    const getContent = () => {
        switch (status) {
            case "ordering":
                return {
                    icon: <ClockCircleOutlined size={16} />,
                    text: "Purchasing...",
                };
            case "waiting_download":
                return {
                    icon: <ClockCircleOutlined size={16} />,
                    text: "Waiting for download...",
                };
            case "downloaded" && article.file:
                return {
                    icon: <CheckCircleOutlined size={16} />,
                    text: "Downloaded",
                };
            case "failed":
                return {
                    icon: <ExclamationCircleOutlined size={16} />,
                    text: "Retry Order",
                };
            default:
                if (article.file) {
                    return {
                        icon: <CheckCircleOutlined size={16} />,
                        text: "Full text already attached",
                    };
                } else {
                    return {
                        icon: <ShoppingCartOutlined size={16} />,
                        text: "Place Article Galaxy Order",
                    };
                }
        }
    };

    const content = getContent();

    return (
        <>
            {content.icon}
            <span>{content.text}</span>
        </>
    );
});

export default ArticleGalaxyMenuItem;
